// Module
var code = "<div id=\"V-26FB070D-7983-40CB-981A-0DDAF8BB0400\"> <div data-b-component=\"content\" data-b-comp-content=\"{Binding Content}\" class=\"stretch-content\"> </div> </div> ";
// Exports
export default code;